import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// Shared stylesheets pinned to the entry chunk. Both are also imported by the
// components that use them; loading them here first fixes their relative
// order, otherwise webpack's CSS extraction warns about conflicting order
// between the lazy chunks that happen to pull in both (and CI treats that
// warning as a build failure).
import './pages/editors/doc-editor/doc-editor.css';
import './pages/flightline/sharedWorkspace.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
